import React from 'react';
import { generateHreflangs } from 'global-config';
import {
  AlternateLanguages,
  Canonical,
  CopySections,
  MetaData,
  ContentAutorules,
  Robots,
} from './components';

const SeoView = () => (
  <>
    <MetaData />
    <Canonical />
    { generateHreflangs && <AlternateLanguages /> }
    <CopySections />
    <ContentAutorules />
    <Robots />
  </>
);

export default SeoView;
